import { FinanceHealthRatioId } from "@ibada/shared-types/finance"

import { OverviewRoutes } from "@/features/finance/overview/lib/overview-nav"

/**
 * What the tenant still knows about a financial-health ratio: WHERE to send someone who wants to see the
 * numbers behind it. Everything else — the value, the variance against the previous period, and the
 * good/warning/critical verdict — is computed on the server from the ledger and arrives with the data
 * (IBA-117). The ratio ids themselves live in `@ibada/shared-types/finance`, so the API and the UI cannot
 * disagree about which ratios exist; the names/explanations/formulas are i18n keys derived from the id.
 */
export const FINANCIAL_RATIO_REPORT_ROUTES: Record<FinanceHealthRatioId, string> = {
  [FinanceHealthRatioId.CurrentRatio]: OverviewRoutes.transactions,
  [FinanceHealthRatioId.QuickRatio]: OverviewRoutes.transactions,
  [FinanceHealthRatioId.DebtRatio]: OverviewRoutes.transactions,
  [FinanceHealthRatioId.OperatingMargin]: OverviewRoutes.transactions,
}
